/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.CancelVoPayInstantResponse,
  CancelVoPayInstantRequest: (params: vp.CancelVoPayInstantRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostCancelVoPayInstant: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldCancelVoPayInstantRequest, setShouldCancelVoPayInstantRequest] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.CancelVoPayInstantRequest>({
    TransactionID: '',
  });
  const [response, setResponse] = useState<vp.CancelVoPayInstantResponse>({
    Success: false,
    ErrorMessage: '',
    TransactionID: '',
    TransactionStatus: '',
    Timestamp: '',
  });

  useEffect(() => {
    if (!shouldCancelVoPayInstantRequest) return () => {};

    const PostCancelVoPayInstant = async () => {
      setDataFetchingInfo(true, 'processing', 'fullScreen');
      const res = await api.postCancelVoPayInstant(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldCancelVoPayInstantRequest) void PostCancelVoPayInstant();
    setShouldCancelVoPayInstantRequest(false);
    return () => {
      source.cancel();
    };
  }, [shouldCancelVoPayInstantRequest]);

  return [
    response,
    (_params: vp.CancelVoPayInstantRequest) => {
      setParams(_params);
      setShouldCancelVoPayInstantRequest(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        TransactionID: '',
        TransactionStatus: '',
        Timestamp: '',
      });
      setShouldCancelVoPayInstantRequest(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostCancelVoPayInstant);
